module.exports = __webpack_public_path__ + "static/media/empower-retail-investors.b2b20cfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empower-retail-investors/empower-retail-investors.png
// module id = 42
// module chunks = 0